const ProductViewStyles = {
    baseStyle: {
        viewStack: {
            body: {
                mr: 4,
                spacing: '10px',
                align: 'flex-start',
                marginLeft: '20px',
                sx: {
                    '& b': {
                        fontFamily: 'heading',
                        fontSize: '26px'
                    },
                    '& s': {
                        fontSize: '14px'
                    },
                    '& span': {
                        fontFamily: 'heading',
                        fontWeight: '400',
                        fontSize: '26px'
                    }
                }
            },
            productName: {
                fontSize: '24px',
                fontFamily: 'caslon',
                fontWeight: '500',
                color: 'black.100',
                whiteSpace: 'normal'
            }
        },
        viewWrapper: {
            setButton: {
                marginBottom: '20px',
                border: '1px solid',
                height: '30px',
                maxWidth: '150px',
                minWidth: '100px',
                padding: '4px 25px',
                backgroundColor: 'white',
                color: 'black.100',
                _hover: {
                    backgroundColor: 'gray.425'
                },
                fontWeight: '400',
                variant: 'solid',
                width: 'auto',
                fontSize: '14px'
            },
            gwpButton: (isYR, showAddedCta) => ({
                backgroundColor: showAddedCta ? 'white' : isYR ? 'black.100' : 'blue.200',
                borderColor: isYR ? 'black.100' : 'blue.200',
                color: showAddedCta ? 'black.100' : isYR ? 'white' : 'black.100',
                height: {base: '32px', xs: '40px'},
                fontSize: {base: '11px', xs: '14px'},
                letterSpacing: {base: '0.055px', xs: '0.07px'},
                padding: '4px 25px',
                lineHeight: '22px',
                fontWeight: '400',
                margin: 0,
                maxWidth: {base: '99px', xs: '131px'},
                _hover: {
                    backgroundColor: showAddedCta ? 'white' : isYR ? 'black.200' : 'blue.100',
                    borderColor: isYR ? 'black.200' : 'blue.100',
                    _disabled: {
                        backgroundColor: 'gray.40',
                        color: 'gray.650',
                        opacity: 1
                    }
                }
            }),
            pdpButton: {
                height: 'auto',
                padding: '15px 50px',
                fontSize: '17px'
            },
            productStack: {
                align: 'stretch',
                spacing: '20px',
                flex: 1,
                width: 'calc(100% - 154px)'
            },
            variationsStack: {
                marginLeft: '20px'
            },
            invalidSelection: {
                color: 'red.400',
                fontSize: '14px',
                letterSpacing: '0.07px',
                lineHeight: '22px',
                fontWeight: '400',
                whiteSpace: 'normal'
            },
            swatchLabel: {
                fontWeight: '300',
                fontSize: '13px',
                color: 'black.100'
            }
        },
        actionWrapper: {
            display: 'inline-flex',
            width: 'full',
            gap: '10px',
            alignItems: 'start'
        }
    },
    variants: {
        gwp: {
            actionWrapper: {
                justifyContent: 'start',
                gap: '15px',
                alignItems: 'center'
            }
        }
    },
    parts: ['viewStack', 'viewWrapper', 'actionWrapper']
}

export default ProductViewStyles
